import { Capacitor } from '@capacitor/core';

/**
 * Utility for detecting the current platform (web, Android, iOS)
 * Used to conditionally show native features like camera capture
 */
export const PlatformUtils = {
  /**
   * Returns true if running in a native app (Android or iOS)
   */
  isNative: (): boolean => {
    return Capacitor.isNativePlatform();
  },

  /**
   * Returns true if running on Android
   */
  isAndroid: (): boolean => {
    return Capacitor.getPlatform() === 'android';
  },

  /**
   * Returns true if running on iOS
   */
  isIOS: (): boolean => {
    return Capacitor.getPlatform() === 'ios';
  },

  /**
   * Returns true if running in a web browser
   */
  isWeb: (): boolean => {
    return Capacitor.getPlatform() === 'web';
  },

  /**
   * Returns the current platform as a string
   */
  getPlatform: (): 'android' | 'ios' | 'web' => {
    return Capacitor.getPlatform() as 'android' | 'ios' | 'web';
  },
};
